export const ToastMessageTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS_TITLE: 'İşlem Başarılı',
  ERROR_TITLE: 'İşlem Başarısız',
  SUCCESS_CARGO_DESCRIPTION: 'Ürünlerin kargo şablonları güncellendi.',
  ERROR_CARGO_DESCRIPTION: 'Ürünlerin kargo şablonları güncellenirken bir hata oluştu.',
  ERROR_APPROVAL_STATUS_DESCRIPTION: 'Ürünlerin onay durumları güncellenirken bir hata oluştu.',
  ERROR_DELETE_DESCRIPTION: 'Ürünler silinirken bir hata oluştu.',
}

export const ToastSuccessMessage = {
  PRICE_UPDATE_SUCCESS: 'Piyasa Satış Fiyatı Başarı ile Güncellendi',
  N11_PRICE_UPDATE_SUCCESS: 'n11 Satış Fiyatı Başarı ile Güncellendi',
  STOCK_UPDATE_SUCCESS: 'Stok Başarı ile Güncellendi',
}

